// extracted by mini-css-extract-plugin
module.exports = {"reviewtabMinWidth":"415px","card_wrapper":"_d68VG","type_review":"i7WTYE","AniFadeIn":"a8JNtC","AniFadeOut":"utdtr6","AniRotate":"Tm8s63","AniPlaceholderFadeOut":"VwkSlQ"};